import { useRef } from "react";

/**
 * Wires token insertion to a textarea's caret. Returns the ref to attach and
 * an insert handler, inserting at the END would put the token in the wrong
 * place for anyone who clicked mid-sentence.
 */
export const useTokenInsert = (
  value: string,
  onChange: (next: string) => void,
) => {
  const ref = useRef<HTMLTextAreaElement>(null);

  const insert = (token: string) => {
    const el = ref.current;
    const at = el?.selectionStart ?? value.length;
    const next = value.slice(0, at) + token + value.slice(at);
    onChange(next);
    requestAnimationFrame(() => {
      el?.focus();
      el?.setSelectionRange(at + token.length, at + token.length);
    });
  };

  return { ref, insert };
};
